import { Button, Card, EmptyState } from '@ui/themed';
import { t } from 'i18next';

export function CustomerGroupEmptyState({ onClick }: { onClick: () => void }) {
  return (
    <Card>
      <EmptyState
        title={t('features:customer_group.components.customer_group_empty_state.title')}
        subtitle={t('features:customer_group.components.customer_group_empty_state.subtitle')}
        imageType="customerGroup"
      >
        <Button onClick={onClick}>
          {t('features:customer_group.pages.customer_groups_page.header.actions.create')}
        </Button>
      </EmptyState>
    </Card>
  );
}
